

import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";

import "@/store/modules/information";
const informationState = namespace("Information");

import "@/store/modules/forms/form17";
const form17State = namespace("Form17");

import { form17DataInfoType } from '@/types/Information/Form17';
import { partiesDataJsonDataType } from '@/types/Information/json';

@Component
export default class Form17StyleOfProceeding extends Vue {

    @informationState.State
    public partiesJson: partiesDataJsonDataType;    

    @informationState.State
    public fileNumber: string;

    @form17State.State
    public form17Info: form17DataInfoType;

    @form17State.Action
    public UpdateForm17Info!: (newForm17Info: form17DataInfoType) => void  
    
    @form17State.State
    public currentCertificateOfCostsId: string;

    @form17State.Action
    public UpdateCurrentCertificateOfCostsId!: (newCurrentCertificateOfCostsId: string) => void
    
    dataReady = false;
    applicantNames: string[] = [];
    respondentNames: string[] = [];
    partyNames: string[] = [];
    otherPartyNames: string[] = [];  

    state = {
        allowedCostsParties:null,
        payingCostsParties: null,        
        amount:null
    }

    respondentName = ""; 
    updated=0;  
    invalidAllowedCostsParties = false;

    mounted() {
        this.dataReady = false;
        this.extractInfo();              
    }

    public extractInfo(){

        this.invalidAllowedCostsParties = false;

        if(this.currentCertificateOfCostsId){
            this.getForm17Data();
           
        } else {   
            
            const form17Data = {} as form17DataInfoType;

            form17Data.appellants = this.partiesJson.appellants
            form17Data.respondents = this.partiesJson.respondents;
            form17Data.formSevenNumber = this.fileNumber;
            
            form17Data.version = this.$store.state.Application.version;  
            
            this.UpdateForm17Info(form17Data);                       
            this.saveForm(true);
        }

    }    

    public extractPartiesData(){

        this.applicantNames = [];
        this.respondentNames = [];
        this.partyNames = [];

        for (const respondent of this.form17Info.respondents){
            this.respondentNames.push(respondent.name); 
            this.partyNames.push(respondent.name) 
        }

        for (const applicant of this.form17Info.appellants){
            this.applicantNames.push(applicant.name);
            this.partyNames.push(applicant.name);  
        }
        this.updateOtherParties()
        this.dataReady = true;

    }

    public getForm17Data() {        
       
        this.$http.get('/form17/forms/'+this.currentCertificateOfCostsId)
        .then((response) => {
            if(response?.data?.data){            
                            
                const form17Data = response.data.data;
                this.UpdateForm17Info(form17Data) 
                this.extractPartiesData();
                this.clearStates();                
            }
                
        },(err) => {
            console.log(err)        
        });      
    }

     public clearStates(){
        this.state = {
            allowedCostsParties:null,
            payingCostsParties: null,        
            amount:null
        }
        this.dataReady = true; 
    }

    public recheckStates(){
        for(const field of Object.keys(this.state)){
            if(this.state[field]==false){
                this.checkStates()
                return 
            }
        }
    }

    public checkStates(){   
                
        this.state.allowedCostsParties = this.form17Info.allowedCostsParties?.length>0? null :false;
        
        this.state.payingCostsParties = this.form17Info.payingCostsParties?.length>0? null :false;
        this.state.amount = !this.form17Info.amount? false : null;       
        
        for(const field of Object.keys(this.state)){
            if(this.state[field]==false){
                Vue.filter('findInvalidFields')()
                return false
            }
        }
        return true            
    }   

    public saveForm(draft: boolean) { 
        
        let method = 'post';
        let url = '/form17/forms';

        if (this.currentCertificateOfCostsId){
            method = 'put';
            url = '/form17/forms/'+this.currentCertificateOfCostsId;               

            if (!draft && !this.checkStates()){               
                return                
            } 
            
            const options = {
                method: method,
                url: url,
                data: {
                    data:this.form17Info,
                    type:'Form17',
                    description:'Certificate of Costs'
                }
            }
            this.saveInfo(options, draft);

        } else {           

            const options = {
                method: method,
                url: url,
                data: {
                    data:this.form17Info,
                    type:'Form17',
                    description:'Certificate of Costs'
                }
            }
            this.saveInfo(options, draft);
        }        
       
    }

    public saveInfo(options, draft){

        this.$http(options)
            .then(response => {
                if(response.data){
                    if(options.method == "post"){
                        this.UpdateCurrentCertificateOfCostsId(response.data.file_id);
                        this.extractPartiesData();                        
                    }

                    this.clearStates();                    
                    if(!draft) this.navigateToPreviewPage();                           
                }
            }, err => {
                const errMsg = err.response.data.error;
                
            })
    }
    
    public updateOtherParties(){

        const otherParties = [];

        if (this.partyNames.length == this.form17Info.allowedCostsParties?.length){

            this.invalidAllowedCostsParties = true;

        } else {

            this.invalidAllowedCostsParties = false;

            for (const partyName of this.partyNames){
                const index = this.form17Info.allowedCostsParties?.indexOf(partyName)
                if (index == -1){
                    otherParties.push(partyName);
                }
            }
            this.otherPartyNames = otherParties;
            this.updated ++;
        }        
    }

    public navigateToPreviewPage() {        
        this.$router.push({name: "preview-form17"}) 
    }

}
